import { Injectable } from "@angular/core";
import {environment} from "../../app/config/environment";
import {MyHttp} from "../../app/core/http";

@Injectable()
export class ProfileService {

  constructor(private http: MyHttp) {}

  updateProfile(profile, role){
    return this.http.post(`${environment.API}/profile/` + role, JSON.stringify(profile))
      .map(res => res.json());
  }

  getProfile(){
    return this.http.get(`${environment.API}/profile`)
      .map(res => res.json());
  }

  getContract(type){
    return this.http.get(`${environment.API}/profile/contracts/${type}`)
      .map(res => res.json());
  }

  getOrganisationUsers(){
    return this.http.get(`${environment.API}/profile/users`)
      .map(res => res.json());
  }

  updateUsersStatus(user){
    return this.http.post(`${environment.API}/profile/users/${user.id}/status`, JSON.stringify(user))
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.service.ts